import { QueryOptions } from "../components/Common/useQuery";
import useUserQuery from "../components/Common/useUserQuery";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";
import { PendingTransportSyncResponse } from "../components/Common/dtos/PendingTransportSyncDto";

const useGetPendingTransportSync = (siteId: string, options?: QueryOptions<PendingTransportSyncResponse>) => {
  const business = useSelectedBusiness();
  return useUserQuery<PendingTransportSyncResponse>({
    path: `/api/businesses/${business.id}/transports/sync/pending?siteId=${siteId}`,
  }, options);
}

export default useGetPendingTransportSync;
